var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const Svg404 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 261,
    viewBox: "0 0 630 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2949 175.212V167.432L170.415 51.667H176.327V66.6822H171.271L110.043 165.332V166.187H202.079V175.212H98.2949ZM172.049 211V172.567V169.066V51.667H181.54V211H172.049Z",
    fill: "#C4CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.018 175.212V167.432L500.138 51.667H506.051V66.6822H500.994L439.766 165.332V166.187H531.802V175.212H428.018ZM501.772 211V172.567V169.066V51.667H511.263V211H501.772Z",
    fill: "#C4CFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.492 114.389C416.468 99.6401 422.092 86.4225 417.316 78.1667C412.539 69.9082 398.251 68.1624 378.956 72.0091M403.492 114.389C390.24 129.452 369.32 146.111 343.978 160.715C293.821 189.618 245.336 199.52 235.684 182.833C230.908 174.577 236.532 161.36 249.509 146.61M403.492 114.389C404.578 119.589 405.15 124.978 405.15 130.5C405.15 173.854 369.937 209 326.5 209C288.596 209 256.954 182.237 249.509 146.61M403.492 114.389C400.005 97.7062 391.213 82.9669 378.956 72.0091M378.956 72.0091C365.039 59.5667 346.655 52 326.5 52C283.063 52 247.851 87.1456 247.851 130.5C247.851 136.022 248.422 141.411 249.509 146.61",
    stroke: "#C4CFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg404);
export default ForwardRef;